/***************************************************************************/
"use client";
/***************************************************************************/

import { useRouter } from "next/navigation";
import React, { useEffect } from "react";

const Redirect: React.FC<{ to: string }> = ({ to }) => {
  const router = useRouter();

  useEffect(() => {
    router.push(to);
  }, [to]);

  return null;
};

export default Redirect;
